import {
	Component,
	Input,
	Output,
	HostListener,
	EventEmitter,
	ElementRef,
	OnChanges,
	SimpleChanges,
	OnInit,
} from '@angular/core';
import { CascaderOptions } from './cascader.model';

@Component({
	selector: 'cv-cascader',
	styleUrls: ['./cascader.component.scss'],
	templateUrl: './cascader.component.html',
})
export class CascaderComponent implements OnChanges, OnInit {
  /**
   * @public property that keeps all the three option that are selected
   */
  path = [];
  /**
   * @public property that keeps the options that you are selecting
   */
  public options: Array<any> = [];
  /**
   * @public property that is deep copy of items data
   */
  public itemsCopy: Array<any> = [];
  /**
   * @public property that show or  hide the component
   */
  isOpen = false;
  /**
   * @public property that set if the element has been touched
   */
  touched = false;
  /**
   * @public property that store the human readable value for the input value key
   */
  __value: any = null;
  /**
   * @public property that recieves if the element value is valid
   */
  @Input() valid = true;
  /**
   * @public property that recieves if the element should be disabled
   */
  @Input() disabled = false;
  /**
   * @public property that recieves the current value of the component
   */
  @Input() value: any = null;
  /**
   * @public property that recieves the component's placeholder
   */
  @Input() placeholder = '';
  /**
   * @public property that recieves the mapping of the attributes that exist in the items
   */

  @Input() configOptions: CascaderOptions = { value: 'key', text: 'value', children: 'children' };
  /**
   * @public property that recieves the list of items to display
   */
  @Input() items: Array<any> = [];
  /**
   * @public property that recieves tabIndex
   */
  @Input() indexTab = 0;
  /**
   * @public property that emit an event when the value has changed
   */
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Constructor
   * * default method of the class that is executed when the class is instantiated
   */
  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {
    this.initialSetUp()
  }
  /**
   * @public method that receive the changes of the component
   */
  ngOnChanges(changes: SimpleChanges): void {
  	const { value } = changes;

  	if (value && value.currentValue && !value.firstChange) {
  		this.resetData();
  		this.initialSetUp();
  	}

  	// if (items && items.currentValue) {
  	//   // this.items = items.currentValue;
  	//   this.itemsCopy = JSON.parse(JSON.stringify(this.items));
  	// }
  }

  /**
   * getTextValue
   * * method that maps passed value to key in items
   */
  private getTextValue(value: any, items: Array<any>): string {
  	let textValue = '';
  	for (const i in items) {
    	if (textValue) {
      	break;
    	} else if (items[i][this.configOptions.children]) {
      	textValue = this.getTextValue(
        	value,
        	items[i][this.configOptions.children]
      	);
    	} else if (items[i][this.configOptions.value] === value) {
      	textValue = items[i][this.configOptions.text];
    	}
  	}
  	return textValue;
  }

  /**
   * HostListener
   * * listener to check if the user clicked outside of the component and hide the lists
   */
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: any): void {
  	const clickedInside = this.eRef.nativeElement.contains(targetElement);
  	if (!clickedInside && this.isOpen) {
    	this.resetData();
    	this.initialSetUp();
  	}
  }

  /**
   * resetData
   * * reset to initial value
   */
  resetData(): void {
  	this.isOpen = false;
  	this.options = [];
  	this.itemsCopy = [];
  }

  /**
   * generateOptions
   * * generate a new list with the items passed to the function
   */
  generateOptions(items: Array<any>): void {
  	if (!items.length) {
    	return;
  	}

  	this.options.push(items);
  }

  /**
   * openOptions
   * * method to show a list of items
   */
  openOptions(): void {
  	if (!this.disabled) {
    	this.touched = true;
    	if (!this.isOpen) {
      	this.isOpen = true;
    	}
    }
  }

  /**
   * selectItem
   * * method executed when you select an item
   */
  selectItem(item: any, listIndex: number): void {
    	this.inactiveAllOptions(this.options[listIndex]);

    	listIndex = listIndex + 1;

  		if (listIndex < this.options.length) {
    		this.options = this.options.splice(0, listIndex);
  		}

  	item.active = true;

    	if (item[this.configOptions.children]) {
    	this.generateOptions(item[this.configOptions.children]);
  	} else {
    	this.valueChange.emit(item);
  	}
  }

  /**
   * initialSetUp
   * method for setting up the data
   */
  private initialSetUp() {
  	// make deep copy of Items
  	this.itemsCopy = JSON.parse(JSON.stringify(this.items));

  	if (this.value) {
    	//set all options.active to false
    	this.inactiveAllOptions(this.itemsCopy);
    	//find path values and set its options.active to true
    	this.setActiveToTrue(this.itemsCopy, this.value);
    	this.__value = this.getTextValue(this.value, this.itemsCopy);
  	} else {
    	this.options.push(this.itemsCopy);
  	}
  }

  /**
   * Change the status of all elements to false
   * @param options
   * @private
   */
  private inactiveAllOptions(options: any): void {
  	options.forEach((option: any) => {
    	option.active = false;
    	if (option.children) {
      	this.inactiveAllOptions(option.children);
    	}
  	});
  }

  /**
   * change selected element to true
   * @param items 
   * @param search 
   * @private
   */
  private setActiveToTrue(items, search) {
  	if (items[this.configOptions.value] === search) {
    	return true;
  	}

  	if (items[this.configOptions.children] || Array.isArray(items)) {
    	const children = Array.isArray(items) ? items : items[this.configOptions.children];
    	for (const child of children) {
      	const result = this.setActiveToTrue(child, search);
      	if (result) {
        	child.active = true;
        	this.options.unshift(children);
        	return result;
      	}
    	}
  	}
  }

  showOptions() {
    this.isOpen = true;
  }
  hideOptions() {
    this.isOpen = false;
  }

	/**
   * Test
   * Selectors
   * $('.cv-cascader-component .action-toggle').click() // Toggle the cascader
   * Once the option list its open:
   * 	$('.cv-cascader-component .cv-cascader__options__list .action-select')[{index_of_item}].click()
   * 	OR look for suboptions:
   * 	$('.cv-cascader-component .cv-cascader__options__list .action-select .has_children')[{index_of_item}].click()
   * 		Example to traverse object:
   * 		$('.cv-cascader-component .cv-cascader__options__list .action-select .has_children').each(function(index,value) {
   *			$(value).click();
   *		});
   *
   * 	Now, you have to select the 2nd or {n} index of the .cv-cascader__options__list:
   * 	$('.cv-cascader-component .cv-cascader__options__list:nth-child({index_of_new_option_list}) .action-select')[{index_of_item}].click()
   * 		Example:
   * 		$('.cv-cascader-component .cv-cascader__options__list:nth-child(2) .action-select')[1].click();
   */
}
